"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FirmBillingErrorMessage;
(function (FirmBillingErrorMessage) {
    FirmBillingErrorMessage["INVITE_NOT_OWNED"] = "The following email address could not be validated. Email address should match the email address to which the invite link was sent.";
    FirmBillingErrorMessage["ACCESS_DENIED"] = "Access is denied. Please contact your Firm Billing Admin.";
    FirmBillingErrorMessage["ALREADY_ACCEPTED"] = "You can't proceed to this invite since you already accepted the invite.";
    FirmBillingErrorMessage["ACTIVE_FIRM_BILLING"] = "You can't proceed to this invite since you already tied to another Firm Org.";
    FirmBillingErrorMessage["ACTIVE_MEMBERSHIP"] = "You can't proceed to this invite since you have an active membership.";
})(FirmBillingErrorMessage = exports.FirmBillingErrorMessage || (exports.FirmBillingErrorMessage = {}));
var InviteErrors;
(function (InviteErrors) {
    InviteErrors["NOT_OWNED"] = "InviteId not owned by user.";
})(InviteErrors = exports.InviteErrors || (exports.InviteErrors = {}));
//# sourceMappingURL=index.js.map